import { Props } from '@web/components/FoldableSearch/foldableSearch.types';
import { FoldableSearch } from '@web/components/FoldableSearch/FoldableSearch';
import { BroadenSearchLabel } from '@web/components/FoldableSearch/BroadenSearchLabel';

export const FoldableSearchBroaden = (props: Props) => {
  return <FoldableSearch {...props} floatingLabel={<BroadenSearchLabel />} />;
};
